module.exports = __webpack_public_path__ + "img/a3_p_m.48ef0109.png";